import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mt-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "card-header cursor-pointer" }, [
  /*#__PURE__*/_createVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createVNode("h3", { class: "fw-bolder m-0" }, "Genealogy")
  ])
], -1)
const _hoisted_3 = { class: "card-body py-3" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_6 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-125px rounded-start" }, "#"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-225px" }, "Name"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-225px" }, "Left"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-300px" }, "Right"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-150px rounded-end" }, "Sponsor")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("table", _hoisted_5, [
          _hoisted_6,
          _createVNode("tbody", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
              return (_openBlock(), _createBlock("tr", { key: index }, [
                _createVNode("td", null, "   " + _toDisplayString(item.positionNo), 1),
                _createVNode("td", null, _toDisplayString(item.fullname) + " (" + _toDisplayString(item.usid) + ")", 1),
                _createVNode("td", null, _toDisplayString(item.lltd), 1),
                _createVNode("td", null, _toDisplayString(item.rltd), 1),
                _createVNode("td", null, _toDisplayString(item.sponsorfullname) + " (" + _toDisplayString(item.spid) + ")", 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}